export const PROFESSIONAL_MAP_SECTIONS = [
  {
    slug: "masters",
    title: "Мастера и специалисты",
    shortTitle: "Мастера",
    eyebrow: "Люди индустрии",
    description:
      "Кондитеры, декораторы, технологи, преподаватели, наставники и профильные специалисты.",
    icon: "users",
    palette: ["#D8B7A2", "#F4E5DA"],
    samples: [
      { title: "Кондитеры", subtitle: "Торты, десерты, частные заказы", roles: ["Кондитер", "Шеф-кондитер"] },
      { title: "Декораторы", subtitle: "Декор, оформление, сложные техники", roles: ["Декоратор"] },
      { title: "Технологи", subtitle: "Рецептуры, производство, процессы", roles: ["Технолог"] },
      { title: "Преподаватели", subtitle: "Обучение, мастер-классы, наставничество", roles: ["Преподаватель", "Наставник"] },
      { title: "Профильные специалисты", subtitle: "Фото, стиль, упаковка, брендинг", roles: ["Фотограф", "Фуд-фотограф", "Фуд-стилист", "Дизайнер упаковки", "Специалист по брендингу"] },
    ],
  },
  {
    slug: "suppliers",
    title: "Поставщики и производство",
    shortTitle: "Поставщики",
    eyebrow: "Материалы и мощности",
    description:
      "Ингредиенты, упаковка, оборудование и инвентарь, цеха и производства.",
    icon: "factory",
    palette: ["#B8B09D", "#EEE9DD"],
    samples: [
      { title: "Ингредиенты", subtitle: "Шоколад, орехи, пюре, декор и другое" },
      { title: "Упаковка", subtitle: "Коробки, ленты, вкладыши, расходные материалы" },
      { title: "Оборудование и инвентарь", subtitle: "Техника, формы, инструменты и всё необходимое для работы" },
      { title: "Цеха и производства", subtitle: "Производственные площадки, контрактное производство, студии и цеха под заказ" },
    ],
  },
  {
    slug: "services",
    title: "Услуги",
    shortTitle: "Услуги",
    eyebrow: "Профессиональная помощь",
    description:
      "Фотосъёмка, дизайн и брендинг, печать, доставка, праздники и мероприятия.",
    icon: "briefcase",
    palette: ["#C4A884", "#F1E4D1"],
    samples: [
      { title: "Фотосъёмка", subtitle: "Предметная и контент-съёмка" },
      { title: "Дизайн и брендинг", subtitle: "Айдентика, упаковка, визуальная система" },
      { title: "Печать", subtitle: "Полиграфия, наклейки, бирки, вкладыши" },
      { title: "Доставка", subtitle: "Курьерские и профильные логистические услуги" },
      { title: "Праздники и мероприятия", subtitle: "Организация праздников, свадеб, банкетов, корпоративов и особенных событий" },
    ],
  },
  {
    slug: "vacancies",
    title: "Работа и сотрудничество",
    shortTitle: "Работа",
    eyebrow: "Работа и партнёрство",
    description:
      "Вакансии, поиск работы, партнёрство и совместные профессиональные проекты.",
    icon: "handshake",
    palette: ["#B9A6A0", "#EEE2DF"],
    samples: [
      { title: "Вакансии", subtitle: "Работа, смены и подработка от работодателей" },
      { title: "Ищу работу", subtitle: "Специалисты, открытые к трудоустройству" },
      { title: "Партнёрство и проекты", subtitle: "Совместные инициативы и профессиональное сотрудничество" },
    ],
  },
];

export const getProfessionalMapSection = (slug) =>
  PROFESSIONAL_MAP_SECTIONS.find((section) => section.slug === slug);


// Keep the five approved Map categories and their concrete professions in one source.
// The editor stores selected role names in the existing owner-private specializations list.
export const PROFESSIONAL_ROLE_GROUPS = PROFESSIONAL_MAP_SECTIONS.find(
  (section) => section.slug === "masters"
)?.samples.map(({ title, roles }) => ({ title, roles })) || [];
